import IndustryItemsService from '@/api/admin/industries.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    industryModel: {},
  },
  getters: {
    getAdminIndustries: state => state.table,
    getIndustryModel: state => state.industryModel,
  },
  actions: {
    async getAdminIndustries({ commit }) {
      const industries = await IndustryItemsService.getAdminIndustries()
      commit('SET_INDUSTRIES', industries)
    },
  },
  mutations: {
    SET_INDUSTRIES(state, industries) {
      state.table.rows = industries
    },
    SET_INDUSTRY_MODEL(state, model) {
      state.industryModel = model
    },
    DELETE_INDUSTRY_MODEL(state, model) {
      state.industryModel = model
    },
    RESET_INDUSTRY_MODEL(state) {
      state.industryModel = {}
    },
  },
}
